import { Dialog, DialogContent, Button, DialogActions, DialogTitle, DialogContentText } from '@mui/material';
import classNames from 'classnames';
import * as React from 'react';

import { t } from 'utils';

type Props = {
  onClose: () => void;
  isOpen: boolean;
  errors: string[];
};

const classes = {
  popup: {
    title: ['popup-title'],
    body: ['popup-body'],
    text: ['popup-text'],
  },
};

let ImportErrorsModal = ({ onClose, isOpen, errors }: Props) => {
  const errorsWithBreaks = errors.reduce<(string | Element | JSX.Element)[]>(
    (acc, error, index) => [...acc, ...((index && [<br key={index} />]) || []), error],
    [],
  );

  return (
    <Dialog open={isOpen} className='results-import-errors-dialog' fullWidth>
      <DialogTitle id='alert-dialog-title' className={classNames(...classes.popup.title)}>
        {t.staticAsString('results.errorsModal.title')}
      </DialogTitle>

      <DialogContent className={classNames(...classes.popup.body)}>
        <DialogContentText className='alert-dialog-description'>
          <>
            <p className='body-title'>{t.staticAsString('results.errorsModal.bodyTitle')}</p>
            {errorsWithBreaks}
          </>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color='primary' autoFocus>
          {t.staticAsString('results.errorsModal.clear')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const DecoratedImportErrorsModal = React.memo<Props>(ImportErrorsModal);

export { DecoratedImportErrorsModal as ImportErrorsModal };
